<template>
  <div class="computer_pay">
    <!--    选择运营商-->
    <van-popup get-container="body" v-model="carrierSelectionShow" :close-on-click-overlay="false">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payable_amount') }}:<span>{{ countryInfo?.currencyCode }}</span>
            <span
              class="computer_pay_payment_account_popup_main_wait_amount_num"
              >{{ formattedPaymentAmount }}</span
            >
          </div>
          <!-- <div class="paymentMethod">
            <div class="paymentMethod_title">Please select a payment method</div>
            <div class="paymentMethod_box">
              <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                   v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                <img class="paymentMethod_item_logo" :src="item.logo" alt="">
                <div class="paymentMethod_item_name">{{ item.name }}</div>

                <img v-if="item.isSelect" class="paymentMethod_item_true" src="@/assets/CI/true.png" alt="">
              </div>
            </div>
          </div> -->
          <div
            @click="carrierSelectionSubmit"
            class="computer_pay_container_step_account_submit"
          >
            <div class="computer_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img
              class="computer_pay_container_step_account_submit_img"
              src="@/assets/cardPay_GH/submit.png"
              alt=""
            />
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </van-popup>

    <!--    付款账号-->
    <van-popup get-container="body" v-model="paymentAccountShow" :close-on-click-overlay="false">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_logo">
            <img
                class="computer_pay_payment_account_popup_main_logo_img"
                :src="
                repaymentData?.configData?.logoFileUrl
                  ? repaymentData.configData.logoFileUrl
                  : countryInfoLogo
              "
                alt=""
            />
          </div>
          <div class="computer_pay_payment_account_popup_main_title">
            {{ countryInfo?.enName === 'TH' ? $t('text_please_fill_payment_method_th') : (operatorList.length ? $t('text_please_fill_payment_method2') : $t('text_please_fill_payment_method')) }}
          </div>
          <div class="computer_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payment_amount') }}:<span>{{ countryInfo?.currencyCode }}</span>
            <span
                class="computer_pay_payment_account_popup_main_wait_amount_num"
            >{{ formattedPaymentAmount }}</span
            >
          </div>
          <template v-if="countryInfo?.enName === 'TH'">
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_customer_name') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box">
                <input
                    v-model="customerName"
                    class="th_form_input"
                    type="text"
                    :placeholder="$t('text_please_enter_customer_name')"
                />
              </div>
            </div>
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_bank_name') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box" @click="bankPopup = true">
                <input
                    class="th_form_input"
                    type="text"
                    readonly
                    :value="customerBankName"
                    :placeholder="$t('text_please_select_bank')"
                />
                <img class="th_form_input_arrow" src="@/assets/1119/arrow.png" alt="">
              </div>
            </div>
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_payment_account_number') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box">
                <input
                    v-model="paymentAccount"
                    class="th_form_input"
                    type="text"
                    :placeholder="$t('text_please_enter_payment_account_number')"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="paymentMethod" v-if="operatorList.length">
              <div class="paymentMethod_title">{{ $t('text_please_select_payment_method') }}</div>
              <div class="paymentMethod_box">
                <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                     v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                  <img v-if="item.logo" class="paymentMethod_item_logo" :src="item.logo" alt="">
                  <div class="paymentMethod_item_name">{{ item.name }}</div>

                  <img v-if="item.isSelect" class="paymentMethod_item_true" src="@/assets/CI/true.png" alt="">
                </div>
              </div>
            </div>
            <div class="computer_pay_container_step_account">
              <div class="computer_pay_container_step_account_input_box">
                <div class="computer_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
                <input
                    v-model="paymentAccount"
                    class="computer_pay_container_step_account_input"
                    type="text"
                    :maxlength="phoneMaxLength"
                    :placeholder="$t('text_please_enter_your_actual_payment_account')"
                />
              </div>
            </div>
          </template>
          <div
              @click="paymentAccountSubmit"
              class="computer_pay_container_step_account_submit"
          >
            <div class="computer_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img
                class="computer_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
            />
          </div>
          <div class="computer_pay_container_step_pay_account" v-if="countryInfo?.enName !== 'TH'">
            <img
                class="computer_pay_container_step_pay_account_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            {{ $t('text_please_fill_your_payment') }}
            <br/>
            {{ $t('text_please_fill_your_payment2') }}
          </div>
          <div style="height: 70px"></div>
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" round v-model="bankPopup" position="bottom">
      <van-picker
          :confirm-button-text="$t('text_confirm')"
          :cancel-button-text="$t('text_return')"
          show-toolbar
          value-key="name"
          :columns="bankList"
          :default-index="0"
          @confirm="bankChange"
          @cancel="bankPopup = false"
      />
    </van-popup>

    <van-popup get-container="body" v-model="editAccountShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_title">
            {{ $t('text_modify_payment_account') }}
          </div>
          <div class="computer_pay_payment_account_popup_main_cur_account">
            {{ $t('text_current_account') }}:<span>{{
              repaymentData.userSubmitAccountNumber
            }}</span>
          </div>
          <div class="computer_pay_container_step_account">
            <div class="computer_pay_container_step_account_input_box">
              <div class="computer_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input
                v-model="editAccountNumber"
                class="computer_pay_container_step_account_input"
                type="text"
                :maxlength="phoneMaxLength"
                :placeholder="$t('text_please_enter_your_actual_payment_account')"
              />
            </div>
            <div
              @click="editAccountSubmit"
              class="computer_pay_container_step_account_submit"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ $t('text_confirm') }}
              </div>
              <img
                class="computer_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
              />
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
            class="computer_pay_payment_account_popup_close"
            @click="editAccountShow = false"
            src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="editAccountConfirmShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_title">
            <img
              class="computer_pay_payment_account_popup_main_title_img"
              src="@/assets/cardPay_NG/danger.png"
              alt=""
            />
            {{ $t('text_remind') }}
          </div>
          <div
            class="computer_pay_payment_account_popup_main_collect_confirm_box"
          >
            {{ $t('text_payment_account_change_once') }}
            <span>{{ editAccountNumber }}</span
            >?
          </div>
          <div class="computer_pay_payment_account_popup_main_confirm_box">
            <div
              @click="submitEditTrxNo"
              class="computer_pay_container_step_account_submit"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ $t('text_confirm2') }}
              </div>
              <img
                class="computer_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
              />
            </div>
          </div>
          <div style="height: 50px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
            class="computer_pay_payment_account_popup_close"
            @click="editAccountConfirmShow = false"
            src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="collectionShow">
      <div class="computer_pay_payment_account_popup">
        <div
          class="computer_pay_payment_account_popup_main"
          v-if="collectionDataStep == 0"
        >
          <div class="computer_pay_payment_account_popup_main_title">
            <img
              class="computer_pay_payment_account_popup_main_title_img"
              src="@/assets/cardPay_NG/danger.png"
              alt=""
            />
            No payment received
          </div>
          <div class="computer_pay_payment_account_popup_main_collect_box">
            <div class="computer_pay_payment_account_popup_main_collect_num">
              Please check whether your payment account and actual payment
              amount are correct.
            </div>
            <div class="computer_pay_payment_account_popup_main_collect_total">
              Payment account:<span>{{
                repaymentData.userSubmitAccountNumber
              }}</span>
              <div
                @click="editAccountShow = true"
                v-if="repaymentData.canEditAccountNumberNumber"
                class="computer_pay_payment_account_popup_main_collect_total_edit"
              >
                <img
                  class="computer_pay_payment_account_popup_main_collect_total_edit_img"
                  src="@/assets/cardPay_GH/edit.png"
                />Modify
              </div>
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div
          class="computer_pay_payment_account_popup_main"
          v-if="collectionDataStep == 1"
        >
          <div class="computer_pay_payment_account_popup_main_title">
            {{ $t('text_get_results') }}
          </div>
          <div class="computer_pay_payment_account_popup_main_collect_box">
            <div class="computer_pay_payment_account_popup_main_collect_num">
              {{ collectionData.transactionNums }} {{ $t('text_transfer_received') }}
            </div>
            <div class="computer_pay_payment_account_popup_main_collect_total">
              {{ $t('text_total_amount2') }}:<span>{{ countryInfo?.currencyCode }} </span
              ><span
                class="computer_pay_payment_account_popup_main_collect_total_amount"
                >{{ collectionData.collectedAmount }}</span
              >
              <div
                @click="collectionDetailShow = true"
                class="computer_pay_payment_account_popup_main_collect_total_detail"
              >
                {{ $t('text_detail') }}
              </div>
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
            class="computer_pay_payment_account_popup_close"
            @click="collectionShow = false"
            src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="collectionDetailShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div
            class="computer_pay_payment_account_popup_main_title computer_pay_payment_account_popup_main_detail_title"
          >
            {{ $t('text_collection_details') }}
          </div>
          <div class="data-box">
            <van-row class="th-row">
              <van-col>{{ $t('text_order_number') }}</van-col>
              <van-col>{{ $t('text_debit_account') }}</van-col>
              <van-col>{{ $t('text_remittance_amount') }}</van-col>
              <van-col>{{ $t('text_payment_time') }}</van-col>
            </van-row>

            <van-row
              class="td-row"
              :style="{ background: index % 2 == 0 ? '#fff' : '#f1f1f1' }"
              v-for="(item, index) in collectionData.collectDetails"
              :key="index"
            >
              <van-col class="common-ellipsis">{{
                item.bankTransactionReference
              }}</van-col>
              <van-col class="common-ellipsis">{{
                item.destinationAccountNumber
              }}</van-col>
              <van-col class="common-ellipsis">{{ item.amount }}</van-col>
              <van-col class="common-ellipsis">{{
                item.transactionTime
              }}</van-col>
            </van-row>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
            class="computer_pay_payment_account_popup_close"
            @click="collectionDetailShow = false"
            src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>
    <van-popup get-container="body" round v-model="operatorPopup" position="bottom">
      <van-picker
          :confirm-button-text="$t('text_confirm')"
          :cancel-button-text="$t('text_return')"
          show-toolbar
          value-key="text"
          :columns="operatorList"
          :default-index="operatorDefaultIndex"
          @confirm="operatorChange"
          @cancel="operatorPopup = false"
      />
    </van-popup>
  </div>
</template>

<script>
import indexJs from "./index.js";

export default {
  name: "Computer",
  mixins: [indexJs],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
.computer_pay {
  position: relative;
  height: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;

  .computer_pay_header {
    width: 100%;
    height: 300px;
    padding-bottom: 16px;
    box-sizing: border-box;
    background: url("~@/assets/cardPay_GH/header.png") no-repeat;
    background-size: 100% 100%;

    .computer_pay_header_content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      box-sizing: border-box;

      .computer_pay_header_time_box {
        .computer_pay_header_time_title {
          margin-top: 50px;
          width: 278px;
          height: 38px;
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #eeeeee;

          background: url("~@/assets/cardPay_GH/tansaction.png") no-repeat;
          background-size: 100% 100%;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .computer_pay_header_time_info {
          display: flex;
          align-items: center;
          margin-top: 25px;
          margin-left: 30px;

          .computer_pay_header_time_item {
            position: relative;
            background-size: 100% 100%;
            margin-right: 5px;
            display: flex;
            align-items: center;

            .computer_pay_header_time {
              font-size: 24px;
              font-family: LucidaGrande;
              color: #eeeeee;

              display: flex;
              align-items: center;
              margin-right: 5px;

              .computer_pay_header_time_item {
                width: 30px;
                height: 36px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 2px;
                border: 1px solid rgba(255, 255, 255, 0.5);

                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .computer_pay_header_text {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #cccccc;
              margin-right: 5px;
            }
          }

          .computer_pay_header_time_left {
            font-size: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #cccccc;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .computer_pay_container {
    position: relative;
    transform: translateY(-116px);
    margin: 0 auto;
    padding-top: 25px;
    padding-bottom: 75px;
    width: calc(100% - 50px);
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    box-sizing: border-box;

    .computer_pay_header_img_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      .computer_pay_header_img {
        width: 54px;
        height: 42px;
        margin-right: 26px;
      }

      .computer_pay_header_text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 26px;
        color: #72695f;

        span {
          color: #f03024;
          margin-left: 10px;
        }
      }
    }

    .computer_pay_container_step {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      padding: 0 145px;
      box-sizing: border-box;

      .computer_pay_container_step_label {
        width: 100px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #2c3855;
      }

      .computer_pay_container_step_value {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;

        span {
          color: #DC811D;
        }
      }
    }

    .computer_pay_container_step_item_box {
      margin: 0 145px;
      border-left: 7px solid #cc8f4e;
      padding: 30px;
      box-sizing: border-box;
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(236, 210, 161, 0.5) 100%
      );
      margin-bottom: 32px;

      .computer_pay_container_step_item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .computer_pay_container_step_item_value {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #DC811D;

          span {
            font-size: 20px;
          }
        }

        .computer_pay_container_step_item_img {
          width: 20px;
          height: 20px;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .computer_pay_container_step_transfer {
        .computer_pay_container_step_item_value {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #948f8a;

          span {
            color: #DC811D;
            margin: 0 8px;
          }

          .computer_pay_container_step_transfer_btn {
            cursor: pointer;
            padding: 6px 15px;
            box-sizing: border-box;
            background: rgba(51, 51, 51, 0.12);
            border-radius: 15px;
            margin-right: 8px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #555555;

            display: flex;
            align-items: center;
            justify-content: center;

            .computer_pay_container_step_transfer_btn_img {
              width: 18px;
              height: 18px;
              margin-right: 4px;
            }
          }
        }
      }
    }

    .computer_pay_container_step_account {
      margin-top: 20px;
      display: flex;
      align-items: center;

      .computer_pay_container_step_account_input_box {
        width: 600px;
        border-radius: 15px;
        border: 1px solid #aaaaaa;
        display: flex;
        align-items: center;
        margin-right: 20px;
      }

      .computer_pay_container_step_233 {
        width: 100px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #DC811D;
        text-align: center;
      }

      .computer_pay_container_step_account_input {
        margin-right: 10px;
        width: 100%;
        height: 80px;
        border: none;
        //padding-left: 20px;

        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #DC811D;
        outline: none;

        &::placeholder {
          color: #bbbbbb;
        }
      }

      .computer_pay_container_step_account_submit {
        cursor: pointer;
        position: relative;
        width: 200px;
        height: 80px;
        background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
        border-radius: 15px;

        font-size: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #996a30;

        display: flex;
        align-items: center;
        justify-content: center;

        .computer_pay_container_step_account_submit_text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }

        .computer_pay_container_step_account_submit_img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(80%, -50%);
          width: 33px;
          height: 18px;
          z-index: 1;
        }
      }
    }

    .computer_pay_container_result {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-right: 80px;
      box-sizing: border-box;
      padding-left: 145px;

      height: 110px;
      background: #f2f2f2;

      .computer_pay_container_result_info {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;

        span {
          color: #DC811D;
          margin-left: 6px;
        }

        .computer_pay_container_result_info_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 30px;
        }

        .computer_pay_container_result_info_btn {
          cursor: pointer;
          padding: 4px 15px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #555555;
          margin-left: 8px;
        }
      }
    }

    .computer_pay_container_result_submit {
      cursor: pointer;
      position: relative;
      margin: 0 auto;
      margin-top: 20px;
      width: 260px;
      height: 80px;
      background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
      border-radius: 15px;

      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996a30;

      display: flex;
      align-items: center;
      justify-content: center;

      .computer_pay_container_result_submit_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .computer_pay_container_result_submit_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(150%, -50%);
        width: 33px;
        height: 18px;
        z-index: 1;
      }
    }

    .computer_pay_container_tips {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      padding-right: 85px;
      margin-top: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #da5b5b;

      .computer_pay_container_tips_img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
  }
}

.computer_pay_payment_account_popup {
  .computer_pay_payment_account_popup_main {
    width: 1020px;
    background: #ffffff;
    border-radius: 15px;
    overflow: hidden;

    .computer_pay_payment_account_popup_main_logo {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 50px;
      box-sizing: border-box;

      .computer_pay_payment_account_popup_main_logo_img {
        height: 100px;
        border-radius: 15px;
      }
    }

    .paymentMethod {
      .paymentMethod_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;
        margin-top: 43px;
        margin-left: 100px;
      }

      .paymentMethod_box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 100px;
        margin-top: 20px;

        .paymentMethod_item {
          position: relative;
          width: 248px;
          height: 152px;
          background: #ffffff;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          border: 1px solid #cccccc;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 0 24px;
          overflow: hidden;

          .paymentMethod_item_logo {
            width: 66px;
            height: 66px;
          }

          .paymentMethod_item_name {
            width: 100%;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #736b5a;
          }

          .paymentMethod_item_true {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 48px;
            height: 48px;
          }
        }

        .paymentMethod_item_s {
          background: rgba(246, 136, 52, 0.08);
          box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
          border-radius: 8px;
          border: 1px solid #dba95a;
        }
      }
    }

    .computer_pay_payment_account_popup_main_title {
      padding-top: 60px;
      margin: 0 100px;
      margin-bottom: 37px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #524535;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .computer_pay_payment_account_popup_main_title_img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }

    .computer_pay_payment_account_popup_main_desc {
      margin-left: 100px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #7f7870;
      line-height: 40px;
    }

    .computer_pay_payment_account_popup_main_detail_title {
      padding-top: 30px;
      margin-left: 30px;
      margin-bottom: 30px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #524535;
    }

    .computer_pay_payment_account_popup_main_collect_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 40px 0;
      box-sizing: border-box;

      .computer_pay_payment_account_popup_main_collect_num {
        width: 100%;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;
      }

      .computer_pay_payment_account_popup_main_collect_total {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #776a5a;

        span {
          color: #DC811D;
          margin-left: 6px;
        }

        .computer_pay_payment_account_popup_main_collect_total_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 30px;
        }

        .computer_pay_payment_account_popup_main_collect_total_detail {
          cursor: pointer;
          padding: 4px 15px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #555555;
          margin-left: 8px;
        }

        .computer_pay_payment_account_popup_main_collect_total_edit {
          cursor: pointer;
          padding: 6px 15px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;
          margin-left: 8px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #555555;

          display: flex;
          align-items: center;
          justify-content: center;

          .computer_pay_payment_account_popup_main_collect_total_edit_img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }
        }
      }
    }

    .computer_pay_payment_account_popup_main_collect_confirm_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 40px 0;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #7f7870;

      span {
        color: #DC811D;
        margin: 0 6px;
      }
    }

    .computer_pay_payment_account_popup_main_cur_account {
      margin-left: 100px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #776a5a;

      span {
        color: #DC811D;
        margin-left: 6px;
      }
    }

    .computer_pay_payment_account_popup_main_wait_amount {
      margin-top: 20px;
      margin-left: 100px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #776a5a;

      span {
        color: #DC811D;
        margin-left: 6px;
      }

      .computer_pay_payment_account_popup_main_wait_amount_num {
        font-size: 30px;
      }
    }

    .computer_pay_container_step_account {
      margin-top: 20px;
      display: flex;
      align-items: center;
      margin-left: 100px;

      .computer_pay_container_step_account_label {
        width: 200px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #555555;
        flex-shrink: 0;
      }

      .required-star {
        color: #DC811D;
        margin-left: 2px;
      }
    }

    .th_form_item {
      display: flex;
      align-items: center;
      margin-left: 100px;
      margin-top: 20px;

      .th_form_label {
        width: 200px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #555555;
        flex-shrink: 0;
      }

      .th_form_input_box {
        width: 600px;
        border-radius: 15px;
        border: 1px solid #aaaaaa;
        display: flex;
        align-items: center;
        padding: 0 15px;
        box-sizing: border-box;

        .th_form_input {
          width: 100%;
          height: 60px;
          border: none;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #DC811D;
          outline: none;

          &::placeholder {
            color: #BBBBBB;
          }
        }

        .th_form_input_arrow {
          width: 20px;
          height: 20px;
          margin-left: 8px;
        }
      }
    }

    .computer_pay_container_step_account_input_box {
      width: 600px;
      border-radius: 15px;
      border: 1px solid #aaaaaa;
      display: flex;
      align-items: center;
      margin-right: 20px;
      padding: 0 15px;
      box-sizing: border-box;

      .computer_pay_container_step_account_input_arrow {
        width: 20px;
        height: 20px;
        margin-left: 8px;
      }
    }
    .computer_pay_container_step_account_select_box{
      font-size: 20px;
    }

    .computer_pay_container_step_233 {
      width: 100px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #DC811D;
      text-align: center;
    }

    .computer_pay_container_step_account_input {
      margin-right: 10px;
      width: 100%;
      height: 80px;
      border: none;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #DC811D;

      outline: none;

      &::placeholder {
        color: #bbbbbb;
      }
    }

    .computer_pay_container_step_pay_account {
      margin-top: 30px;
      padding: 20px 0;
      background: rgba(218, 91, 91, 0.1);
      padding-left: 100px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #da5b5b;

      .computer_pay_container_step_pay_account_img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
    }

    .computer_pay_container_step_account_submit {
      margin: 0 auto;
        margin-top: 20px;
      cursor: pointer;
      position: relative;
      width: 200px;
      height: 80px;
      background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
      border-radius: 15px;

      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996a30;

      display: flex;
      align-items: center;
      justify-content: center;

      .computer_pay_container_step_account_submit_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .computer_pay_container_step_account_submit_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(80%, -50%);
        width: 33px;
        height: 18px;
        z-index: 1;
      }
    }

    .computer_pay_payment_account_popup_main_confirm_box {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .computer_pay_payment_account_popup_close_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .computer_pay_payment_account_popup_close {
      cursor: pointer;
      width: 50px;
      height: 50px;
    }
  }
}

.data-box {
  .th-row {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 86px;
    background: rgba(122, 122, 122, 0.1);
    border-radius: 15px 15px 0px 0px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #524535;
  }

  .td-row {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #7f7870;
  }

  ::v-deep .van-col {
    flex: 1;
    text-align: center;
  }
}

// 超出 1 行显示省略号
.common-ellipsis {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 滚动条位置 --展示的是竖向
// /deep/.__bar-is-vertical {
// right: -1px !important;
// }
// // 隐藏横向滚动条
// /deep/.__bar-is-horizontal {
// display: none !important;
// }

// 滚动条位置 --展示横向
:deep(.__bar-is-vertical) {
  display: none !important;
}

// 隐藏横向滚动条
:deep(.__bar-is-horizontal) {
  bottom: -1px !important;
}
</style>
